
import { Component, Prop, Vue } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
import api from "@/api";
import placeholderImage from "@/assets/undraw_Images_re_0kll_transparent.png";

@Component({
  components: { EditFrame },
})
export default class UpdateableImage extends Vue {
  @Prop({
    required: true,
  })
  img!: File | null;

  @Prop({
    required: true,
  })
  width!: string;

  @Prop({
    required: true,
  })
  height!: string;

  @Prop({
    required: false,
  })
  iconSize!: string;

  @Prop({
    required: false,
    default: false,
  })
  contain!: boolean;

  @Prop({
    required: true,
  })
  allowedFileType!: string;

  // Internal state
  imageError = false;

  get imageUrl() {
    if (this.img) {
      return URL.createObjectURL(this.img);
    }
    return undefined;
  }

  get brokenImagePlaceholder() {
    return placeholderImage;
  }

  get uploadIconSize() {
    return this.iconSize ? "24" : "24";
  }

  onImageError() {
    this.imageError = true;
  }

  onImageLoad() {
    this.imageError = false;
  }

  onUploadImage() {
    const input = document.createElement("input");
    const allImageTypes = "image/*";
    input.type = "file";
    input.accept = this.allowedFileType;
    input.onchange = async () => {
      if (input.files && input.files.length > 0) {
        const file = input.files[0];
        if (
          this.allowedFileType !== file.type &&
          this.allowedFileType !== allImageTypes
        ) {
          alert("Nur der Dateityp " + this.allowedFileType + " ist zulässig.");
        }
        this.$emit("upload", file);
      }
      document.body.removeChild(input);
    };
    document.body.appendChild(input);
    input.click();
  }
}
